module.exports = __webpack_public_path__ + "static/owlbear_cub_mtg_clb-e71dbaa6f2d4e7f8c942972827d8b923.png";